import { useEffect } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import ReplaceChar from "../../../../components/Formatters/ReplaceChar";

const useGerarComunicado = ({ dadosOs, atividade, formik }) => {
  const {
    request: gerarComunicadoRequest,
    data: gerarComunicadoData,
    errors: gerarComunicadoErrors,
    isLoading: gerarComunicadoIsLoading,
  } = useApiClient();

  const gerarComunicado = () => {
    const parametros = {
      sequencialAcaoFiscal: dadosOs.acaoFiscal,
      sequencialOrdemServico: dadosOs.sequencial,
      sequencialComunicado: dadosOs.sequencialComunicado,
      sequencialAtividade: atividade.sequencialAtividade,
      siglaAtividade: atividade.siglaAtividade,
      nomeAtividade: atividade.nomeAtividade,
      textoComunicado: ReplaceChar(formik.values.textoImpedimento),
      txDescricao: ReplaceChar(formik.values.txDescricao),
      textoDadosContribuinte: dadosOs.sequencial + dadosOs.inscricaoEstadual + dadosOs.cnpjCpf + dadosOs.razaoSocial,
      anexos: formik.values.anexos,
    };

    gerarComunicadoRequest(apiRoutes.fiscalizacao.ordemservico.gerarComunicado, parametros);
  };

  useEffect(() => {
    if (gerarComunicadoIsLoading) return;

    if (gerarComunicadoErrors) {
      toast.error(gerarComunicadoErrors.message);
    }
  }, [gerarComunicadoData, gerarComunicadoErrors, gerarComunicadoIsLoading]);

  return { gerarComunicadoIsLoading, gerarComunicado, gerarComunicadoErrors, gerarComunicadoData };
};

export default useGerarComunicado;
